import { render } from "./NotificationWindow.vue?vue&type=template&id=279a1c50&scoped=true"
import script from "./NotificationWindow.vue?vue&type=script&lang=js"
export * from "./NotificationWindow.vue?vue&type=script&lang=js"

import "./NotificationWindow.vue?vue&type=style&index=0&id=279a1c50&lang=scss"
import "./NotificationWindow.vue?vue&type=style&index=1&id=279a1c50&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279a1c50"]])

export default __exports__